/* ============================================================
   SHADOWKICKS — Theme JS
   ============================================================ */

'use strict';

// ── Cart Drawer ───────────────────────────────────────────────
class CartDrawer {
  constructor() {
    this.drawer  = document.getElementById('cart-drawer');
    this.overlay = document.getElementById('cart-overlay');
    this.body    = document.getElementById('cart-drawer-body');
    this.subtotalEl = document.getElementById('cart-drawer-subtotal');
    this.countEl    = document.querySelectorAll('.cart-count');

    document.querySelectorAll('[data-open-cart]').forEach(el =>
      el.addEventListener('click', e => { e.preventDefault(); this.open(); })
    );
    document.querySelectorAll('[data-close-cart]').forEach(el =>
      el.addEventListener('click', () => this.close())
    );
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());
  }

  open() {
    this.refresh();
    this.drawer.classList.add('is-open');
    this.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  close() {
    this.drawer.classList.remove('is-open');
    this.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async refresh() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
    } catch(e) { console.error('Cart refresh failed', e); }
  }

  render(cart) {
    this.countEl.forEach(el => el.textContent = cart.item_count);
    if (this.subtotalEl) {
      this.subtotalEl.textContent = this.formatMoney(cart.total_price);
    }
    if (!this.body) return;
    if (cart.items.length === 0) {
      this.body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      return;
    }
    this.body.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item__image" src="${item.image}" alt="${item.title}" loading="lazy">
        <div class="cart-item__details">
          <div class="cart-item__title">${item.product_title}</div>
          <div class="cart-item__variant">${item.variant_title || ''}</div>
          <div class="cart-item__price">${this.formatMoney(item.final_line_price)}</div>
          <button class="cart-item__remove" data-key="${item.key}">Remove</button>
        </div>
      </div>
    `).join('');

    this.body.querySelectorAll('.cart-item__remove').forEach(btn =>
      btn.addEventListener('click', () => this.removeItem(btn.dataset.key))
    );
  }

  async removeItem(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    this.refresh();
  }

  formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }
}

// ── Add to Cart ───────────────────────────────────────────────
class AddToCart {
  constructor() {
    document.querySelectorAll('[data-add-to-cart]').forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault();
        this.submit(form);
      });
    });
  }

  async submit(form) {
    const btn = form.querySelector('[type=submit]');
    const originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    const id = form.querySelector('[name=id]')?.value;
    if (!id || id === '') {
      btn.textContent = 'Select a size';
      setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2000);
      return;
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ id, quantity: 1 })
      });
      if (!res.ok) throw new Error('Failed');
      btn.textContent = 'Added ✓';
      window.cartDrawer?.refresh();
      setTimeout(() => window.cartDrawer?.open(), 300);
    } catch(e) {
      btn.textContent = 'Error — try again';
    }
    setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2000);
  }
}

// ── Size Selector ─────────────────────────────────────────────
class SizeSelector {
  constructor() {
    document.querySelectorAll('.size-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-unavailable')) return;
        const group = btn.closest('.size-grid');
        group.querySelectorAll('.size-btn').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        const hiddenId = btn.closest('form')?.querySelector('[name=id]');
        if (hiddenId) hiddenId.value = btn.dataset.variantId;
      });
    });
  }
}

// ── Product Gallery ───────────────────────────────────────────
class ProductGallery {
  constructor() {
    document.querySelectorAll('.product-gallery__thumb').forEach((thumb, i) => {
      thumb.addEventListener('click', () => this.switchImage(thumb));
    });
  }

  switchImage(thumb) {
    const gallery = thumb.closest('.product-gallery');
    gallery.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
    const main = gallery.querySelector('.product-gallery__main img');
    if (main) main.src = thumb.dataset.src || thumb.src.replace('_80x80', '_800x800');
  }
}

// ── FAQ Accordion ─────────────────────────────────────────────
class FAQ {
  constructor() {
    document.querySelectorAll('.faq-item__question').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.faq-item');
        const isOpen = item.classList.contains('is-open');
        document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('is-open'));
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }
}

// ── Mobile Menu ───────────────────────────────────────────────
class MobileMenu {
  constructor() {
    const toggle = document.getElementById('mobile-menu-toggle');
    const menu   = document.getElementById('mobile-menu');
    const close  = document.getElementById('mobile-menu-close');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', () => menu.classList.add('is-open'));
    close?.addEventListener('click', () => menu.classList.remove('is-open'));
  }
}

// ── Search Overlay ────────────────────────────────────────────
class SearchOverlay {
  constructor() {
    const openBtns = document.querySelectorAll('[data-open-search]');
    const overlay  = document.getElementById('search-overlay');
    const closeBtn = document.getElementById('search-close');
    const input    = overlay?.querySelector('.search-overlay__input');
    if (!overlay) return;
    openBtns.forEach(b => b.addEventListener('click', () => {
      overlay.classList.add('is-open');
      input?.focus();
    }));
    closeBtn?.addEventListener('click', () => overlay.classList.remove('is-open'));
    overlay.addEventListener('click', e => {
      if (e.target === overlay) overlay.classList.remove('is-open');
    });
  }
}

// ── Cart Page QTY ─────────────────────────────────────────────
class CartQuantity {
  constructor() {
    document.querySelectorAll('.qty-decrease, .qty-increase').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const delta = btn.classList.contains('qty-increase') ? 1 : -1;
        const span = btn.closest('.cart-line__qty').querySelector('span');
        const newQty = Math.max(0, parseInt(span.textContent) + delta);
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ id: key, quantity: newQty })
        });
        window.location.reload();
      });
    });
  }
}

// ── Init ──────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  window.cartDrawer = new CartDrawer();
  new AddToCart();
  new SizeSelector();
  new ProductGallery();
  new FAQ();
  new MobileMenu();
  new SearchOverlay();
  new CartQuantity();
});
